import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import "./AdminDashboard.css"

const AdminDashboard = () => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  if (!userInfo || userInfo.user?.role !== 1) {
    // If not logged in or not an admin, redirect to home page (or login page)
    return <Navigate to="/" replace />;
  }

  return (
    <div className="admin-dashboard">
      <AdminSidebar />
      <div className="admin-main-content">
        <Outlet /> {/* This will load child admin routes */}
      </div>
    </div>
  );
};

export default AdminDashboard;
